module.exports = __webpack_public_path__ + "media/images/area/area_hiroshimaM400-602ed62676c3090ec69137eb674ff696.jpg";